/** IDs of lessons to remove for "this and following" (matches setLessons filter logic below). */
export function getFollowingRecurringDeleteIds(pending, allLessons) {
  if (!pending || !allLessons?.length) return [];
  const lessonDate = new Date(pending.date);
  if (pending.recurringId) {
    return allLessons
      .filter((l) => {
        if (l.recurringId !== pending.recurringId) return false;
        const lDate = new Date(l.date);
        return lDate >= lessonDate;
      })
      .map((l) => l.id);
  }
  return allLessons
    .filter((l) => {
      const lDate = new Date(l.date);
      const isSameSeries =
        l.type === pending.type &&
        l.studentId === pending.studentId &&
        l.from === pending.from &&
        l.to === pending.to &&
        (l.title === pending.title || !l.title || !pending.title);
      const isSameOrAfter =
        lDate.getFullYear() > lessonDate.getFullYear() ||
        (lDate.getFullYear() === lessonDate.getFullYear() && lDate.getMonth() > lessonDate.getMonth()) ||
        (lDate.getFullYear() === lessonDate.getFullYear() &&
          lDate.getMonth() === lessonDate.getMonth() &&
          lDate.getDate() >= lessonDate.getDate());
      return isSameSeries && isSameOrAfter;
    })
    .map((l) => l.id);
}
